import { formatRelative } from 'date-fns';
import sv from './customDateFnsSwedish';

export default function formatCloseRelative(
    date: Date | number,
    format: 'default' | 'includeTime' | 'noTime' = 'default',
    now: Date = new Date(),
): string {
    const formatRelativeLocale = {
        default: defaultFormat,
        includeTime: includeTimeFormat,
        noTime: noTimeFormat,
    }[format];

    const locale = {
        ...sv,
        formatRelative: (token) => formatRelativeLocale[token],
    };

    return formatRelative(date, now, { locale });
}

const defaultFormat = {
    lastWeek: 'P',
    yesterday: "'igår kl.' HH.mm",
    today: "'idag kl.' HH.mm",
    tomorrow: "'imorgon kl.' HH.mm",
    nextWeek: 'P',
    other: 'P',
};

const includeTimeFormat = {
    lastWeek: "P 'kl.' HH.mm",
    yesterday: "'igår kl.' HH.mm",
    today: "'idag kl.' HH.mm",
    tomorrow: "'imorgon kl.' HH.mm",
    nextWeek: "P 'kl.' HH.mm",
    other: "P 'kl.' HH.mm",
};

const noTimeFormat = {
    lastWeek: 'P',
    yesterday: "'igår'",
    today: "'idag'",
    tomorrow: "'imorgon'",
    nextWeek: 'P',
    other: 'P',
};
